<template>
  <div>
    <ul class="flex-cen-cen">
      <li v-for="item in colorData" :key="item.text" :style="{color:item.color||'transparent','background-image':item.grad,'--bg':item.bg}" :class="{txt:!item.color,bg:item.bg,trans:item.transparent}">{{item.text}}</li>
    </ul>
    <p class="flex-cen-cen">
      难度：
      <span :class="{active:level>=1}" @click="setLevel(1)" @mouseenter="hoverLevel=1" @mouseleave="hoverLevel=level"/>
      <span :class="{active:level>=2||hoverLevel>=2}" @click="setLevel(2)" @mouseenter="hoverLevel=2" @mouseleave="hoverLevel=level" />
      <span :class="{active:level>=3||hoverLevel>=3}" @click="setLevel(3)" @mouseenter="hoverLevel=3" @mouseleave="hoverLevel=level" />
    </p>
  </div>
</template>

<script>
export default {
  data(){
    return {
      colorData: [],
      level: 1,
      hoverLevel: 1,
    }
  },
  mounted(){
    this.setLevel(1)
  },
  methods: {
    setLevel(n){
      this.level = n
      let text = ['红','黄','蓝','绿','紫','橙','粉'].sort(() => Math.random() - 0.5)
      let color = ['red','#dcc500','#0017dc','#00a001','#a402a4','#ee7e00','#ffa1b1'].sort(() => Math.random() - 0.5)
      let len = text.length
      let arr = []
      if (n == 1) {
        for (let i = 0; i < len; i++) {
          arr.push({color: color[i], text: text[i]})
        }
      } else if (n == 2) {
        let rand = Math.floor(Math.random() * len)
        for (let i = 0; i < len; i++) {
          if (i == rand) arr.push({color: 'transparent', text: text[i], transparent: 1})
          else arr.push({color: color[i], text: text[i]})
        }
      } else {
        let rand1 = Math.floor(Math.random() * len)
        let rand2 = Math.floor(Math.random() * len)
        while (rand1 == rand2) {
          rand2 = Math.floor(Math.random() * len)
        }
        for (let i = 0; i < len; i++) {
          if (i==rand1 || i==rand2) {
            arr.push({color: 'transparent', text: text[i], transparent: 1})
          } else {
            let ppercentArr = [40,60]
            let percent = ppercentArr[Math.floor(Math.random()*2)]
            let color1 = color[Math.floor(Math.random() * len)]
            let color2 = color[Math.floor(Math.random() * len)]
            let bgcolor = color[Math.floor(Math.random() * len)]
            while (color1 == color2) color2 = color[Math.floor(Math.random() * len)]
            while (bgcolor==color1 || bgcolor==color2) bgcolor = color[Math.floor(Math.random() * len)]
            arr.push({grad: `linear-gradient(to bottom, ${color1} ${percent}%,  ${color2} ${percent}%)`, text: text[i], bg: bgcolor})
          } 
        }
      }
      this.colorData = arr
    }
  }
}
</script>

<style lang="scss" scoped>
ul{
  height: 90vh;
  user-select: none;
}
li{
  font-size: 60px;
  margin: 0 20px;
  font-weight: bold;
  color: #b9b9b9;
  line-height: 1;
  padding: 10px 10px 18px;
  border-radius: 6px;
  // border: 2px solid transparent;
  -webkit-background-clip: text;
  // text-shadow: 0 0 2px rgba(0,0,0,.3);
  
}
.txt{border-color: #b9b9b9;}
.wink{animation: wink 1s linear infinite;}
.turn{animation: turn 1s linear infinite;}
.bg{
  position: relative;
  &::before{
    content: '';
    position: absolute;
    border-radius: 6px;
    background: var(--bg);
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: -1;
    opacity: .6;
  }
}
.trans{
  -webkit-text-stroke: 1px #b3b3b3;
  color: transparent;
}
p{
  text-align: center;
  height: 10vh;
  span{
    width: 30px;
    height: 24px;
    background: url('../assets/images/company/star1.png') no-repeat;
    background-size: 24px 24px;
    background-position: center center;
    cursor: pointer;
  }
  .active{background-image: url('../assets/images/company/star2.png');}
}
@keyframes wink {
  0%{opacity: 1;}
  50%{opacity: 0;}
  100%{opacity: 1;}
}
@keyframes turn {
  50%{transform: rotate(180deg);}
  100%{transform: rotate(360deg);}
}
@media screen and (max-width: 800px) {
  li{margin: 0 10px;font-size: 40px;}
}
@media screen and (max-width: 520px) {
  ul{flex-direction: column;}
  li{margin: 5px 10px;}
}
</style>
